import React from 'react';
import Dashboard from '../pages/dashboard/Dashboard';
// Wenn du später eigene Routen für Pending/Hostcodes nutzt, importiere sie in App.js statt hier.

export default function AdminPanel() {
  return <Dashboard />;
}
